import {pathBuilder} from "../misc/utils"
import {removeNullValues} from "../misc/utils"
import {navigationPaths} from "./navigation-path"
import {getMerkmal} from "../misc/widget-functions"

export const KundeActions = ({
    getDataFromPointer,
    updateData,
    navigate,
    getDataFromBackend,
    sendDataToBackend,
    loadCurrentLocationData,
    getDataFromBackendWithQuery,
    setToDefault,
}) => {
    const resetSearchFields = () => {
        updateData({}, "/suche/juristischeperson")
        updateData({}, "/suche/natuerlicheperson")
    }
    return {
        UPDATE_BEITRAGSSATZ_KUNDE: ({value}) => {
            updateData(value.beitragssatz, "/kunde/krankenkasse/beitragssatz")
        },
        UPDATE_BEITRAGSSATZ_KIND: ({value, widget}) => {
            const pointer = getMerkmal(widget)?.pointer
            const indexFromPointer = pointer.split("/").at(-2)
            updateData(value.beitragssatz, `/kinder/${indexFromPointer}/krankenkasse/beitragssatz`)
        },
        UPDATE_BEITRAGSSATZ_EHEPARTNER: ({value}) => {
            updateData(value.beitragssatz, "/ehepartner/krankenkasse/beitragssatz")
        },
        INIT_SUCHE: () => {
            loadCurrentLocationData("/suche").then(() => {
                updateData({}, "/suche")
                resetSearchFields()
            })
        },
        NP_SUCHE: () => {
            getDataFromBackendWithQuery(
                getDataFromPointer("/links/sucheNp"),
                "/suche/result/natuerlicheperson",
                getDataFromPointer("/suche/natuerlicheperson"),
            )
        },
        NAVIGATE_NP_KUNDE_ANLEGEN: () => {
            navigate(navigationPaths.NP_KUNDE_ANLEGEN)
            resetSearchFields()
        },
        NAVIGATE_VERSORGUNG: () => {
            navigate("/versorgunsguebersicht/id")
            resetSearchFields()
        },
        NP_KUNDE_ANLEGEN: () => {
            sendDataToBackend(
                getDataFromPointer("/links/createNp"),
                getDataFromPointer("/natuerlicheperson"),
            ).then(() => {
                navigate(navigationPaths.SUCHE)
                updateData({}, "/suche/natuerlicheperson")
            })
        },
        SELECT_NP_KUNDE: ({payload}) => {
            navigate(pathBuilder(payload._links._self))
        },
        CREATE_ADDRESS_NP: () => {
            sendDataToBackend(
                getDataFromPointer("/natuerlicheperson/_links/adresse:create"),
                getDataFromPointer("/adressen/adresse"),
            ).then(() => {
                getDataFromBackend(
                    getDataFromPointer("/natuerlicheperson/_links/adresseList"),
                    "/adressen/adresselist",
                )
                setToDefault("/adressen/adresse")
            })
        },
        EDIT_ADDRESS: ({payload}) => {
            updateData(
                {
                    adressType: "",
                    strasse: "",
                    hausnummer: "",
                    postleitzahl: "",
                    ort: "",
                    land: "",
                    hauptadresse: false,
                    adressegueltig: false,

                    ...removeNullValues(payload),
                },
                "/adressen/adresse",
            )
        },
        UPDATE_ADDRESS: () => {
            sendDataToBackend(
                getDataFromPointer("/adressen/adresse/_links/adresseUpdate"),
                getDataFromPointer("/adressen/adresse"),
            ).then(() =>
                getDataFromBackend(
                    getDataFromPointer("/juristischeperson/_links/adresseList"),
                    "/adressen/adresselist",
                ),
            )
        },
        INIT_KUNDE_NP: () => {
            loadCurrentLocationData("/natuerlicheperson").then(
                () => {
                    Promise.all([
                        getDataFromBackend(
                            getDataFromPointer(
                                "/natuerlicheperson/_links/anbahnungList",
                            ),
                            "/suche/anbahnungList",
                        ),
                        getDataFromBackend(
                            getDataFromPointer(
                                "/natuerlicheperson/_links/adresseList",
                            ),
                            "/adressen/adresselist",
                        ),
                    ])
                },
                () => {},
            )
        }
    }
}
